import { render, staticRenderFns } from "./ques8.vue?vue&type=template&id=45c06056"
import script from "./ques8.vue?vue&type=script&lang=js"
export * from "./ques8.vue?vue&type=script&lang=js"
import style0 from "./ques8.vue?vue&type=style&index=0&id=45c06056&prod&lang=css"
import style1 from "./ques8.vue?vue&type=style&index=1&id=45c06056&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports